var React = require('react');

function PlusCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0013 18.7922C14.6037 18.7922 18.3346 15.0612 18.3346 10.4588C18.3346 5.85645 14.6037 2.12549 10.0013 2.12549C5.39893 2.12549 1.66797 5.85645 1.66797 10.4588C1.66797 15.0612 5.39893 18.7922 10.0013 18.7922Z","stroke":"current","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10 7.12549V13.7922","stroke":"current","strokeWidth":"1.5","strokeLinecap":"square","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.66797 10.459H13.3346","stroke":"current","strokeWidth":"1.5","strokeLinecap":"square","strokeLinejoin":"round","key":2})]);
}

PlusCircle.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = PlusCircle;

PlusCircle.default = PlusCircle;
